import React, { useContext, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { Toaster} from 'react-hot-toast'
import AppContainer from "../../../Components/Structure/AppContainer";
import useStateCallback from '../../../util/customHooks/useStateCallback';
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AttachStudent from '../../../Components/Parents/AdminProfile/AttachStudent';
import ContactContext from '../../../Context/ContactContext';
import ContactChildren from '../../../Components/Parents/ContactChildren';
import SummaryCount from '../../../Components/Parents/SummaryCount';
import ContactBioData from '../../../Components/Parents/ContactBioData';
import UserContacts from '../../../Components/Parents/UserContacts';
import ContactCallLogs from '../../../Components/Parents/ContactCallLogs';
import ContactTransactions from '../../../Components/Parents/ContactTransactions';
import Pagination from '../../../Components/Common/Pagination';
import RemoteLogOut from '../../RemoteLogOut';
import SetDefaultPIN from '../../../Components/Parents/AdminProfile/SetDefaultPIN';
import ConvertCreditToPM from '../../../Components/Parents/AdminProfile/ConvertCreditToPM';

const ParentProfilePage = props => {

  const {contactProfile, contactUserId, contactWalletBalance, contactCount, setContactId, setContactUserId, userContacts,
    contactLogs, contactTransactions, loading3, contactChildren, transactionMeta, transactionPage, setTransactionPage,
    getContactProfile, getUserContacts, countContactContacts, getContactChildren, getContactWalletBalance, getContactWalletTransactions} = useContext(ContactContext);
  const {id, user_id} = useParams();
  const [modal, setModal] = useStateCallback(false);
  
  useEffect(() => {
    setContactId(id);
  }, [id, setContactId]);

  useEffect(() => {
    setContactUserId(user_id);
  }, [user_id, setContactUserId]);
    
  const handleModal2=()=>{
    setModal(false, ()=>setModal(<AttachStudent contactPhone={contactProfile.username} contactName={contactProfile.full_name} g={getContactChildren} h={getUserContacts} i={countContactContacts} isOpen={true}/>))
  }

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= transactionMeta) {
      setTransactionPage(newPage);
    }
  };

  const remoteLogout = () => {
    setModal(false, () =>
      setModal(
        <RemoteLogOut
          userID={user_id}
          isOpen={true}
        />
      )
    );
  };

  const setDefaultPIN = () => {
    setModal(false, () =>
      setModal(
        <SetDefaultPIN
          userID={user_id}
          g={getContactProfile}
          isOpen={true}
        />
      )
    );
  };

  const convertCredit = () => {
    setModal(false, () =>
      setModal(
        <ConvertCreditToPM
          userID={user_id}
          studentList={contactChildren}
          h={getContactWalletBalance}
          j={getContactWalletTransactions}
          cpage={transactionPage}
          isOpen={true}
        />
      )
    );
  };

  return (
    <AppContainer title={"Contact Profile"} >
      <Toaster
          position="top-center"
          reverseOrder={false}
      />
      {modal}
        
      <section class="section profile">
        <div class="row">
          <div class="col-xl-4">
            <div className="row">
              <div class="col-lg-12">
                <div class="cards gradient-my-blue" style={{borderRadius:"10px"}}>
                  <div class="cards">
                    <div class="card-body profile-card pt-4 d-flex flex-column gradient-my-blue" style={{padding:"20px"}}>
                      <div class="main-img-user mb-2" style={{justifyContent:"center", display:"flex"}}>
                        <img
                          alt="avatar"
                          style={{ height: "150px", borderRadius:"50%", padding:"5px"}}
                          src={
                        process.env.PUBLIC_URL +
                        "/assets/img/figure/user55.png"
                      }
                        />
                      </div>
                      <h3 style={{ color: "white", textAlign:"center", margin:"10px 0"}}>
                        {contactProfile?.full_name}
                      </h3>
                      <h5 style={{ color: "white", textAlign:"center", margin:"0" }}>{contactProfile.username}</h5>
                      
                    </div>
                  </div>
                </div>
               
                <ul class="list-group list-group-flush bg" style={{display: "flex", flexDirection: "column", paddingLeft: "0", borderTop: "#dee2e6 solid 5px"}}>
                    
                    <li class="p-0 list-group-item">
                        <div class="grid-menu grid-menu-2col">
                            <div class="no-gutters row" style={{marginRight: "0", marginLeft: "0", display:"grid"}}>
                               <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={convertCredit} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-users btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", "color":"#ffc107"}}> </i>Convert Credit to Student Pocket Money
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={setDefaultPIN} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-user-gear btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", "color":"#117a8b"}}> </i>Set Default PIN
                                    </button>
                                </div>
                                <div class="col-sm-12" style={{borderRight: "#dee2e6 solid 5px", borderBottom: "#dee2e6 solid 5px"}}>
                                    <button onClick={remoteLogout} class="btn-icon-vertical btn-square btn-transition btn btn-outline-link" style={{padding: "1rem" , minWidth: "100%", backgroundColor:"white", fontSize: "14px", display: "flex",flexDirection:"row-reverse", justifyContent:"space-between", alignItems:"center"}}>
                                        <i class="fa fa-arrow-right-from-bracket btn-icon-wrapper btn-icon-lg" style={{display: "block", margin: "0", fontSize: "2.5rem !important", lineHeight: "1", "color":"#DE3163"}}> </i>Remote Logout
                                    </button>
                                </div>
                               
                               
                                
                            </div>
                        </div>
                    </li>
                </ul>
                
              </div>
              
              <ContactChildren children={contactChildren} handleModal2={handleModal2} getContactChildren={getContactChildren} user_id={contactUserId}/>

             
               
            </div>
            

           

            
          </div>

          <div className="col-xl-8">
            <div className="row">
              <SummaryCount contactCount={contactCount} walletBalance={contactWalletBalance}/>

              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body pt-3">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                      <Row>
                        <Col sm={12}>
                          <Nav variant="pills" className="flex-row mb-1">
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="first">
                                Contact Bio-Data{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="second">
                                Contacts{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="third">
                                Call Logs{" "}
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link size="sm" eventKey="fourth">
                                Transactions{" "}
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>
                            <Tab.Pane eventKey="first">

                              <ContactBioData contactProfile={contactProfile}/>
                              
                            </Tab.Pane>

                            <Tab.Pane eventKey="second">

                              <UserContacts contactList={userContacts} getParentContacts={getUserContacts} countParentContacts={countContactContacts}/>

                            </Tab.Pane>

                            <Tab.Pane eventKey="third">

                              <ContactCallLogs logsList={contactLogs}/>
                              
                            </Tab.Pane>
                            <Tab.Pane eventKey="fourth">

                              <ContactTransactions walletTransactions={contactTransactions} loading3={loading3}/>
                              <Pagination currentPage={transactionPage} totalPages={transactionMeta} onPageChange={handlePagination}/>
                              
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </AppContainer>
  )
}

export default ParentProfilePage;